<template><div><h2 id="dashed-borders" tabindex="-1" class="d-docsite--header-2">Dashed Borders <a class="header-anchor d-link d-docsite--link d-link" href="#dashed-borders" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-b{a|t|r|b|l}s-dashed</code> to change the border style to dashed on your element.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bas-dashed&quot;&gt;d-bas-dashed&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bts-dashed&quot;&gt;d-bts-dashed&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-brs-dashed&quot;&gt;d-brs-dashed&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bbs-dashed&quot;&gt;d-bbs-dashed&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bls-dashed&quot;&gt;d-bls-dashed&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="100" :direction="{ 'default': 'column', 'md': 'row' }">
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bas-dashed">d-bas-dashed</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bts-dashed">d-bts-dashed</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-brs-dashed">d-brs-dashed</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bbs-dashed">d-bbs-dashed</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bls-dashed">d-bls-dashed</div>
</dt-stack>
</code-example>
<h2 id="dotted-borders" tabindex="-1" class="d-docsite--header-2">Dotted Borders <a class="header-anchor d-link d-docsite--link d-link" href="#dotted-borders" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-b{a|t|r|b|l}s-dotted</code> to change the border style to dotted on your element.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bas-dotted&quot;&gt;d-bas-dotted&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bts-dotted&quot;&gt;d-bts-dotted&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-brs-dotted&quot;&gt;d-brs-dotted&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bbs-dotted&quot;&gt;d-bbs-dotted&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bls-dotted&quot;&gt;d-bls-dotted&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="100" :direction="{ 'default': 'column', 'md': 'row' }">
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bas-dotted">d-bas-dotted</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bts-dotted">d-bts-dotted</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-brs-dotted">d-brs-dotted</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bbs-dotted">d-bbs-dotted</div>
  <div class="d-p-200 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bls-dotted">d-bls-dotted</div>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr>
        <th scope="row" class="d-code--sm d-docsite-code">.d-bas-unset</th>
        <td class="d-code--sm">border-style: unset !important;</td>
      </tr>
    </tbody>
    <tbody v-for="s in ['dashed', 'dotted']">
      <tr v-for="i in ['all', 'top', 'right', 'bottom', 'left']">
        <th scope="row" class="d-code--sm d-docsite-code">.d-b{{ i[0] }}s-{{ s }}</th>
        <td class="d-code--sm">
          <span v-if="i === 'all'">border-style: {{ s }} !important;</span>
          <span v-else>border-{{ i === 'top' ? 'block-start' : i === 'bottom' ? 'block-end' : i === 'left' ? 'inline-start' : i === 'right' ? 'inline-end' : i }}-style: {{ s }} !important;</span>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


